import { inject } from "mobx-react";

import { ResponsiveImage } from "../../../../core/components/ResponsiveImage.component";
import { CoastSearchItemFragment } from "@ihr-radioedit/inferno-webapi";
import { getCoastFeedImg, CoastFeedItemType } from "../../lib/coastFeed";
import { DATETIME_DISPLAY_FORMATS } from "@inferno/renderer-shared-core";
import { MagicLink, DateTimeDisplay } from "../../../../core/ui";
import { formatImage } from "@ihr-radioedit/inferno-core";
import { trimText } from "../../../../core/lib/utilities";

import { RESPONSIVE_IMAGE } from "../../../../core/ui/constants";
import type { Store } from "@inferno/renderer-shared-core";
export interface SearchItemProps {
  item: CoastSearchItemFragment;
  store?: Store;
}

export const SearchItem = inject("store")(({ item, store }: SearchItemProps) => {
  const isExternalItem = item.category === "external";

  if (!store || (isExternalItem && (!item.source || !item.source_url))) {
    return null;
  }

  const { env } = store;

  let itemUrl: string;
  let target: string;
  let category: string;

  if (isExternalItem && item.source_url) {
    itemUrl = item.source_url;
    category = "article";
    target = "_blank";
  } else {
    itemUrl = `/${item.category}/${item.slug}/`;
    category = item.category;
    target = "_self";
  }

  const thumb = formatImage(item.summary.image ?? "", env.IMAGE_HOST);
  const { imgSrc, srcset } = getCoastFeedImg(thumb, CoastFeedItemType.ARTICLE, { quality: 80 });

  return (
    <div className="component-coast-search-item">
      <figure className="item-thumb">
        <MagicLink to={itemUrl} context={item.slug ?? undefined} target={target} external={isExternalItem}>
          <ResponsiveImage
            src={imgSrc}
            srcset={srcset}
            alt={item.summary.title}
            initialWidth={RESPONSIVE_IMAGE.responsiveImageInitialWidth}
            initialHeight={RESPONSIVE_IMAGE.responsiveImageInitialHeight}
          />
        </MagicLink>
      </figure>

      <MagicLink
        className="item-title"
        to={itemUrl}
        context={item.slug ?? undefined}
        target={target}
        external={isExternalItem}
      >
        {item.summary.title}
      </MagicLink>

      <p className="item-meta">
        <span className="item-category">{category}</span>
        {category !== "guest" ? (
          <>
            &nbsp;|&nbsp;
            <DateTimeDisplay
              timestamp={item.pub_start.timestampMs}
              format={DATETIME_DISPLAY_FORMATS.SHORT_MONTH_DAY_FULL_YEAR}
              className="item-published"
            />
          </>
        ) : null}
      </p>

      <p className="item-summary">
        {trimText(item.summary.description, 250)}
        <br />
        {item.source && <em>&#8212;&nbsp;{item.source}</em>}
      </p>
    </div>
  );
});
